import * as o from "react";
import r from "./chunk830.js";
import t from "./chunk822.js";
import m from "./chunk831.js";
function i() {
  const e = m(r);
  return process.env.NODE_ENV !== "production" && o.useDebugValue(e), e[t] || e;
}
export {
  i as default
};
